<mat-card style="min-height: 500px">
    <mat-card-content>
      <!-- <div class="d-flex justify-content-end mb-4">
          <button *ngIf="auth.permissions['SCHOOL_PROGRAM_RULE_VIEW']" class="action-btn action-btn-create" type="button" (click)="viewRules()">Year Level Rules</button>
      </div> -->
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div>
          <div class="fw-bold fs-5 mb-1">
            Global Rules
          </div>
          <div class="small-text mb-3">
            {{ 'GLOBAL_RULES_DESC_01' | translate }}
          </div>
        </div>
        <div>
          <button
            *ngIf="auth.permissions['SCHOOL_PROGRAM_GLOBAL_RULE_INPUT_ALL']"
            class="action-btn action-btn-create"
            type="button"
            (click)="openModalInputAll()">
            Input For All Locations
          </button>
        </div>
      </div>
        <div class="max-width">
          <div class="form-group row mb-3">
              <!-- <div class="col-md-3">
                  <app-select-academic-year-only
                      (academicYearChanged)="onChangeAcademicYear($event)">
                  </app-select-academic-year-only>
              </div> -->
              <div class="col-md-3" style="display: none;">
                  <app-select-school-level-relation-v2
                      [academic_year]="currentAcademic?.academic_year"
                      (eventData)="onGetEventSchoolLocation($event)">
                  </app-select-school-level-relation-v2>
              </div>
          </div>
        </div>
        <div *ngIf="loading && !showData" class="d-flex justify-content-center align-items-center">
          <mat-spinner></mat-spinner>
        </div>
        <div class="table-responsive">
          <div *ngIf="dataGlobalRules.length === 0 && !loading" class="d-flex justify-content-center align-items-center">
            <app-status-no-data></app-status-no-data>
          </div>
          <table class="table global-rules-table" *ngIf="dataGlobalRules.length > 0 && !loading">
            <thead>
              <tr>
                <th class="text-start">School</th>
                <th class="text-start">Minimum</th>
                <th class="text-start">Maximum</th>
                <th class="text-start">Valid From</th>
                <th class="text-end">Action</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let element of dataGlobalRules">
                <ng-container *ngIf="element.loc_global_rule.length > 0; else noGlobalRule">
                  <tr *ngFor="let loc of element.loc_global_rule; let isFirst = first">
                    <td *ngIf="isFirst" class="school-cell" [attr.rowspan]="element.loc_global_rule.length + 1">
                      {{ element.school_short_address || '-' }}
                    </td>
                    <td>{{ loc.minimum_selection || '-' }}</td>
                    <td>{{ loc.maximum_selection || '-' }}</td>
                    <td>{{ loc.valid_from | date:'fullDate' }}</td>
                    <td>
                      <div class="d-flex flex-wrap gap-1 justify-content-end">
                        <button
                          *ngIf="auth.permissions['SCHOOL_PROGRAM_GLOBAL_RULE_EDIT']"
                          class="action-icon-btn action-icon-edit"
                          type="button"
                          (click)="onEditGlobalRules(loc.global_rule_id)"
                          [title]="'EDIT' | translate">
                          <div>
                            <i-feather name="edit-2" class="feather-base"></i-feather>
                          </div>
                        </button>
                        <button
                          *ngIf="auth.permissions['SCHOOL_PROGRAM_GLOBAL_RULE_DELETE']"
                          class="action-icon-btn action-icon-delete"
                          type="button"
                          (click)="onDeleteGlobalRules(loc.global_rule_id)"
                          [title]="'DELETE' | translate">
                          <div>
                            <i-feather name="trash-2" class="feather-base"></i-feather>
                          </div>
                        </button>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #noGlobalRule>
                  <tr>
                    <td class="school-cell" rowspan="2">{{ element.school_short_address || '-' }}</td>
                    <td colspan="3" class="empty-rule-cell">No global rule configured.</td>
                    <td>-</td>
                  </tr>
                </ng-template>
                <tr class="add-rule-row">
                  <td colspan="4" class="text-end">
                    <button
                      *ngIf="auth.permissions['SCHOOL_PROGRAM_GLOBAL_RULE_ADD']"
                      class="action-icon-btn action-icon-create"
                      type="button"
                      (click)="onOpenAddModal(element.school_location_id)"
                      [title]="'ADD' | translate">
                      <div>
                        <i-feather name="plus" class="feather-base"></i-feather>
                      </div>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #editRule let-modal let-close="close">
    <form (ngSubmit)="onSaveGlobalRules()" [formGroup]="editRuleForm">
        <div class="modal-header">
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">{{ 'Edit Global Rule' | translate }}</h5>
                </div>
            </div>
        </div>
        <ng-container>
            <div class="modal-body">
                <div class="row float-start mb-5 d-grid col-md-12" *ngIf="showDetail">
                    <div class="d-grid mb-2 col-md-12">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Valid From' | translate }}</span>
                        <input type="date" class="form-control col-md-3" placeholder="{{ 'Valid From' | translate }}" formControlName="valid_from">
                    </div>
                    <div class="row mb-2">
                      <div class="col-6">{{ 'Min Selection' | translate }}</div>
                      <div class="col-6">{{ 'Max Selection' | translate }}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-6">
                        <input class="form-control" type="number" formControlName="minimum_selection" />
                      </div>
                      <div class="col-6">
                        <input class="form-control" type="number" formControlName="maximum_selection" />
                      </div>
                    </div>
                    <span *ngIf="invalidMinMaxEdit" style="font-size: 14px; color: rgb(190, 0, 0);">
                      *minimum selection must be less than maximum selection
                    </span>

                    <div class="d-flex justify-content-end">
                        <button *ngIf="auth.permissions['SCHOOL_PROGRAM_GLOBAL_RULE_EDIT']" type="submit" class="btn btn-success col-md-2 mt-4 me-1" [disabled]="invalidMinMaxEdit">{{ 'Save' | translate }}</button>
                    </div>
                </div>
            </div>
        </ng-container>
    </form>
</ng-template>

<ng-template #addRule let-modal let-close="close">
    <form (ngSubmit)="onAddGlobalRules()" [formGroup]="addRuleForm">
        <div class="modal-header">
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">{{ 'Add Global Rule' | translate }}</h5>
                </div>
            </div>
        </div>
        <ng-container>
            <div class="modal-body">
                <div class="row float-start mb-5 d-grid col-md-12">
                    <div class="d-grid mb-2 col-md-12">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Valid From' | translate }}</span>
                        <input type="date" class="form-control col-md-3" placeholder="{{ 'Valid From' | translate }}" formControlName="valid_from">
                    </div>
                    <div class="row mb-2">
                      <div class="col-6">{{ 'Min Selection' | translate }}</div>
                      <div class="col-6">{{ 'Max Selection' | translate }}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-6">
                        <input class="form-control" type="number" formControlName="minimum_selection" />
                      </div>
                      <div class="col-6">
                        <input class="form-control" type="number" formControlName="maximum_selection" />
                      </div>
                    </div>
                    <span *ngIf="invalidMinMaxAdd" style="font-size: 14px; color: rgb(190, 0, 0);">
                      *minimum selection must be less than maximum selection
                    </span>

                    <div class="d-flex justify-content-end">
                        <button *ngIf="auth.permissions['SCHOOL_PROGRAM_GLOBAL_RULE_ADD']" type="submit" class="btn btn-success col-md-2 mt-4 me-1" [disabled]="invalidMinMaxAdd">{{ 'Save' | translate }}</button>
                    </div>
                </div>
            </div>
        </ng-container>
    </form>
</ng-template>

<ng-template #inputAll let-modal let-close="close">
    <form (ngSubmit)="onAddGlobalRulesForAll()" [formGroup]="addRuleFormForAll">
        <div class="modal-header">
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">{{ 'Add Global Rule For All Locations' | translate }}</h5>
                </div>
            </div>
        </div>
        <ng-container>
            <div class="modal-body">
                <div class="row float-start mb-5 d-grid col-md-12">
                    <div class="d-grid mb-2 col-md-12">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Valid From' | translate }}</span>
                        <input type="date" class="form-control col-md-3" placeholder="{{ 'Valid From' | translate }}" formControlName="valid_from">
                    </div>
                    <div class="row mb-2">
                      <div class="col-6">{{ 'Min Selection' | translate }}</div>
                      <div class="col-6">{{ 'Max Selection' | translate }}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-6">
                        <input class="form-control" type="number" formControlName="minimum_selection" />
                      </div>
                      <div class="col-6">
                        <input class="form-control" type="number" formControlName="maximum_selection" />
                      </div>
                    </div>
                    <span *ngIf="invalidMinMaxAddForAll" style="font-size: 14px; color: rgb(190, 0, 0);">
                      *minimum selection must be less than maximum selection
                    </span>

                    <div class="d-flex justify-content-end">
                        <button *ngIf="auth.permissions['SCHOOL_PROGRAM_GLOBAL_RULE_INPUT_ALL']" type="submit" class="btn btn-success col-md-2 mt-4 me-1" [disabled]="invalidMinMaxAddForAll">{{ 'Save' | translate }}</button>
                    </div>
                </div>
            </div>
        </ng-container>
    </form>
</ng-template>
